module.exports = require("md5");